<template>
  <v-card :elevation="$root.ele" flat class="mt-4">
    <v-card-text>
      <v-autocomplete
        v-model="model"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        hide-details=""
        outlined
        item-text="name"
        item-value="id"
        dense
        hide-no-data
        placeholder="Search by name or job number or phone"
        prepend-inner-icon="mdi-magnify"
        @change="openJob"
      >
        <template v-slot:item="data">
          <template>
            <v-list-item-content v-if="typeof data.item == 'object'">
              <v-list-item-title v-html="data.item.name"></v-list-item-title>
            </v-list-item-content>
          </template>
        </template>
      </v-autocomplete>
    </v-card-text>
  </v-card>
</template>

<script>
import { customers } from "../../assets/js/firebase";
export default {
  data() {
    return {
      isLoading: false,
      model: null,
      search: null,
      items: [],
    };
  },
  watch: {
    search() {
      this.initSearch();
    },
  },
  methods: {
    getName({ fields, name, job_number }) {
      return `${name} - ${fields.Phone} - #${job_number}`;
    },
    openJob() {
      const vm = this;
      vm.items = [];
      vm.$router.push(`/jobs/${vm.model}`);
      vm.model = null;
    },
    async initSearch() {
      const vm = this;
      if (vm.search.length < 3) return;
      if (vm.isLoading) return;
      vm.isLoading = true;
      vm.items = [];
      let queryText = vm.search.toLowerCase();
      try {
        let snap = await customers
          .where("name_lower", ">=", queryText)
          .where("name_lower", "<=", queryText + "\uf8ff")
          .where("status", "in", [1, 2, 3, 5, 6, 7])
          .limit(5)
          .get();
        snap.docs.forEach((item) => {
          let doc = item.data();
          doc.name = vm.getName(doc);
          doc.id = item.id;
          vm.items.push(doc);
        });
        snap = await customers
          .where("fields.Phone", ">=", queryText)
          .where("fields.Phone", "<=", queryText + "\uf8ff")
          .where("status", "in", [1, 2, 3, 5, 6, 7])
          .limit(5)
          .get();
        snap.docs.forEach((item) => {
          let doc = item.data();
          doc.name = vm.getName(doc);
          doc.id = item.id;
          vm.items.push(doc);
        });
        snap = await customers
          .where("job_number", "==", Number(queryText))
          .where("status", "in", [1, 2, 3, 5, 6, 7])
          .limit(5)
          .get();
        snap.docs.forEach((item) => {
          let doc = item.data();
          doc.name = vm.getName(doc);
          doc.id = item.id;
          vm.items.push(doc);
        });
        vm.isLoading = false;

        if (vm.search.length > 3 && queryText.length < vm.search.length) {
          console.log("passed");
          vm.initSearch();
        }
        console.log(this.isLoading);
      } catch (error) {
        console.log(error.message);
        vm.isLoading = false;
      }
    },
  },
  mounted() {},
};
</script>

<style></style>
